import React, { Component } from 'react';
import { Provider, connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { Layout, Modal } from 'antd';
import appRs from './App.reducer'
import configureStore from './store';
import Routers from './router/index'
import AppSider from './components/AppSider/index';
import AppHeader from './components/AppHeader/index';
import AppBreadcrumb from './components/AppBreadcrumb/index';

import { fetchUserBaseInfo, fetchUserAuthInfo, SET_ORGLIST } from './App.action'
import { getMerchantOrgList, merchantChangeTo, sysnoticeRead } from './api'
import PhoneBind from './components/PhoneBind'
import ExpireModal from './components/ExpireModal'
import SchoolSelect from './components/SchoolSelect'
import AccountBind from './components/AccountBind'
import './App.less';
import police from './assets/police.png'
const { Content, Footer } = Layout;

const store = configureStore()

class AppLayout extends Component {
    constructor() {
        super()
        this.state = {
            initReady: false,
            globalModal: {
                config: {
                    visible: false,
                    maskClosable: false,
                    keyboard: false,
                    closable: false
                },
                content: null
            },
            refresh: false,
            currentYear: new Date().getFullYear()
        }
    }

    checkSysnotice = async () => {
      let { appRs: { userInfo, sysnotice } } = this.props;
      let this_ = this;
      if(!userInfo.expired && userInfo.showSysNotice && this.props.location.pathname !== '/login' && !this.state.globalModal.config.visible) {
        Modal.info({
          title: '通知',
          width: '40%',
          okText: '我已知晓',
          content: (<div dangerouslySetInnerHTML={{__html: sysnotice.content}}></div>),
          onOk() {
            this_.sysnoticeread(userInfo.orgId);
          },
        });
      }
    }

    sysnoticeread = async (orgId) => {
      let { appRs: { sysnotice } } = this.props;
      await sysnoticeRead({orgId,sysNoticeId:sysnotice.sysNoticeId});
    }

    globalInit = async () => {
        this.setState({
            initReady: false
        })
        let { dispatch, appRs: { userInfo } } = this.props
        let closeModal = (initReady = true) => {
            this.setState({
                initReady,
                globalModal: {
                    config: {
                        visible: false,
                    }
                }
            })
        }

        let checkOrgId = async () => {
            let orgList = await getMerchantOrgList()
            if (orgList.length === 1) {
                let orgId = orgList[0].id
                sessionStorage.setItem('orgId', orgId)
                dispatch(fetchUserAuthInfo(orgId))
                this.setState({
                    initReady: true
                })
            } else {
                let orgId = sessionStorage.getItem('orgId')
                if (orgId) {
                    dispatch(fetchUserAuthInfo(orgId))
                    this.setState({
                        initReady: true
                    })
                } else {
                    let onSelectChange = async (orgId) => {
                        await merchantChangeTo({orgId});
                        window.location.href = window.location.href;
                        // window.location.reload();
                    }
                    this.setState({
                        globalModal: {
                            config: {
                                title: "请选择学校",
                                visible: true,
                                maskClosable: false,
                                keyboard: false,
                                closable: false,
                            },
                            content: <SchoolSelect style={{ width: '100%' }} orgList={orgList} onSelectChange={(orgId) => onSelectChange(orgId)}></SchoolSelect>
                        }
                    })
                }
            }
            dispatch({
                type: SET_ORGLIST,
                orgList
            })
            this.checkSysnotice();
        }
        if (!userInfo.identity) {
            await dispatch(fetchUserBaseInfo())
        }
        userInfo = this.props.appRs.userInfo
        if (userInfo.identity !== 'Guest') {
            await dispatch(fetchUserAuthInfo())
            userInfo = this.props.appRs.userInfo
            if ((userInfo.identity === "Admin" || userInfo.identity === "SystemAdmin")) {
                if ((!userInfo.phoneNo || !userInfo.aliUserId) && userInfo.bindSkipped === false) {
                    this.setState({
                        globalModal: {
                            config: {
                                title: "账号绑定",
                                visible: true,
                                maskClosable: false,
                                keyboard: false,
                                closable: false,
                            },
                            content: <PhoneBind onSkipped={closeModal} onChecked={closeModal} dispatch={dispatch} userInfo={userInfo}></PhoneBind>
                        }
                    })
                } else {
                    this.setState({
                        initReady: true
                    })
                }
                this.checkSysnotice();
            } else if ((userInfo.identity === "Merchant" || userInfo.identity === "SystemMerchant")) {
                // 先判断是否为第一次登录，需要设置一个账号密码
                if (!userInfo.userName) {
                    let onSubmited = () => {
                        closeModal(false)
                        checkOrgId()
                    }
                    this.setState({
                        globalModal: {
                            config: {
                                title: "初次登录,需要设置一个账号密码,用于下次查询和登录",
                                visible: true,
                                maskClosable: false,
                                keyboard: false,
                                closable: false,
                            },
                            content: <AccountBind onSubmited={onSubmited}></AccountBind>
                        }
                    })
                } else {
                    // 再判断是否存在orgId
                    checkOrgId()
                }
            } else {
                this.setState({
                    initReady: true
                })
                this.checkSysnotice();
            }
        } else {
            this.setState({
                initReady: true
            })
            this.checkSysnotice();
        }

    }

    componentDidMount() {
        this.globalInit()
    }
    componentWillReceiveProps (nextProps, nextState) {
        if (this.props.location.pathname !== nextProps.location.pathname){
          this.setState({
            refresh: Math.ceil(Math.random()*100)
          })
        }
    }
    render() {
        const { globalModal: { config: modalConfig, content: ModalContent }, initReady, refresh, currentYear } = this.state
        const { location, appRs: { userInfo } } = this.props
        if (userInfo.identity === 'Guest' && location.pathname !== '/login') {
            return <Redirect to="/login"></Redirect>
        }
        return <Layout className={location.pathname.replace('/', '')}>
            {initReady && <AppSider></AppSider>}
            {initReady && <Layout>
                <AppHeader></AppHeader>
                <Content>
                    <AppBreadcrumb></AppBreadcrumb>
                    <Switch>
                        {Routers.map((item, index) => {
                            return <Route key={index} path={item.path} exact render={props => {
                                return <item.component globalInit={item.path === '/login' && this.globalInit} {...props} />
                            }} />
                        })}
                    </Switch>
                </Content>
                <Footer>
                    {location.pathname === '/login' && <ul>
                        <li><a href="//www.yunban.com" target="_blank" rel="noopener noreferrer">云瓣校园</a></li>
                        <li><a href="//d.yunban.com" target="_blank" rel="noopener noreferrer">云瓣电子校园卡</a></li>
                        <li><a href="//s.yunban.com" target="_blank" rel="noopener noreferrer">云瓣商家中心</a></li>
                        <li><a href="//jft.yunban.com" target="_blank" rel="noopener noreferrer">云瓣缴费通</a></li>
                    </ul>}
                    <div>
                        Copyright © 2012 - { currentYear } Yunban. All Rights Reserved.
                        {
                            location.pathname === '/login' ? '云瓣科技有限公司' : <a target="_blank" rel="noopener noreferrer" href="//www.yunban.com">云瓣科技有限公司</a>
                        }
                        版权所有 沪ICP备14019811号-2 <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502013871" rel="noopener noreferrer" target="_blank">沪公网安备 31011502013871号<img className="police" alt="" src={police}/></a>
                    </div>
                </Footer>
            </Layout>}
            {modalConfig.visible && <Modal
                destroyOnClose
                centered={true}
                footer={null}
                {...modalConfig}
            >
                {ModalContent}
            </Modal>}
            {userInfo.expired && !modalConfig.visible && location.pathname !== '/login' && <ExpireModal key={refresh}/>}
        </Layout>
    }
}

const WrapLayout = withRouter(connect(appRs)(AppLayout))
class App extends Component {

    render() {
        return (
            <Provider store={store}>
                <Router>
                    <WrapLayout>
                    </WrapLayout>
                </Router>
            </Provider>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx